// import React, { useState, useEffect } from 'react';
// import { Card, Row, Col, Typography, Button, Tag, Skeleton, Space, Avatar, Modal, Drawer } from 'antd';
// import { 
//   CalendarOutlined, 
//   ClockCircleOutlined, 
//   UserOutlined, 
//   ReadOutlined,
//   RightOutlined,
//   FireOutlined,
//   EyeOutlined,
//   CloseOutlined 
// } from '@ant-design/icons';
// import newsService from "../../services/course.service";

// const { Title, Text, Paragraph } = Typography;

// const NewsSection = () => {
//   const [news, setNews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedArticle, setSelectedArticle] = useState(null);
//   const [detailModalVisible, setDetailModalVisible] = useState(false);
//   const [allNewsVisible, setAllNewsVisible] = useState(false);
//   const [allNews, setAllNews] = useState([]);
//   const [loadingAllNews, setLoadingAllNews] = useState(false);

//   useEffect(() => {
//     fetchLatestNews();
//   }, []);

//   const fetchLatestNews = async () => {
//     try {
//       setLoading(true);
//       const data = await newsService.getLatestNews(6);
//       console.log('Données actualités reçues:', data);
//       setNews(data || []);
//     } catch (error) {
//       console.error('Erreur lors du chargement des actualités:', error);
//       setNews([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchAllNews = async () => {
//     try {
//       setLoadingAllNews(true);
//       const data = await newsService.getAllNews();
//       console.log('Toutes les actualités reçues:', data);
//       setAllNews(data || []);
//     } catch (error) {
//       console.error('Erreur lors du chargement de toutes les actualités:', error);
//       setAllNews([]);
//     } finally {
//       setLoadingAllNews(false);
//     }
//   };

//   const handleArticleClick = (article) => {
//     setSelectedArticle(article);
//     setDetailModalVisible(true);
//   };

//   const handleViewAllNews = () => {
//     fetchAllNews();
//     setAllNewsVisible(true);
//   };

//   const closeDetailModal = () => {
//     setDetailModalVisible(false);
//     setSelectedArticle(null);
//   };

//   const closeAllNewsDrawer = () => {
//     setAllNewsVisible(false);
//     setAllNews([]);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return '';
//     try {
//       const date = new Date(dateString);
//       return date.toLocaleDateString('fr-FR', {
//         day: 'numeric',
//         month: 'long',
//         year: 'numeric'
//       });
//     } catch (error) {
//       return '';
//     }
//   };

//   const getCategoryColor = (category) => {
//     const colors = {
//       'elearning': '#1890ff',
//       'technology': '#722ed1',
//       'education': '#52c41a',
//       'innovation': '#faad14',
//       'updates': '#f5222d',
//       'events': '#13c2c2',
//       'default': '#666'
//     };
//     return colors[category?.toLowerCase()] || colors.default;
//   };

//   // Images par défaut par catégorie
//   const getDefaultImage = (category) => {
//     const defaultImages = {
//       'elearning': 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=600&h=400&fit=crop',
//       'technology': 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=600&h=400&fit=crop',
//       'education': 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600&h=400&fit=crop',
//       'innovation': 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=400&fit=crop',
//       'updates': 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop',
//       'events': 'https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=600&h=400&fit=crop',
//       'default': 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop'
//     };
//     return defaultImages[category?.toLowerCase()] || defaultImages.default;
//   };

//   // Fonction robuste pour gérer les images
//   const processImageSrc = (article) => {
//     console.log(`Traitement image pour "${article.title}":`, {
//       hasImageData: !!article.imageData,
//       imageType: article.imageType,
//       dataLength: article.imageData?.length
//     });

//     // Pas de données d'image
//     if (!article.imageData || article.imageData.trim() === '') {
//       console.log(`Utilisation image par défaut pour "${article.title}"`);
//       return getDefaultImage(article.category);
//     }

//     try {
//       // Image de type URL
//       if (article.imageType === 'url') {
//         // Vérifier que l'URL est valide
//         if (article.imageData.startsWith('http://') || article.imageData.startsWith('https://')) {
//           return article.imageData;
//         } else {
//           console.warn(`URL invalide pour "${article.title}":`, article.imageData);
//           return getDefaultImage(article.category);
//         }
//       }

//       // Image de type base64
//       if (article.imageType === 'base64') {
//         let base64Data = article.imageData;

//         // Si déjà formaté avec data:
//         if (base64Data.startsWith('data:')) {
//           // Vérifier la longueur pour éviter les erreurs
//           if (base64Data.length > 100000) {
//             console.warn(`Image base64 trop longue pour "${article.title}", utilisation image par défaut`);
//             return getDefaultImage(article.category);
//           }
//           return base64Data;
//         }

//         // Formater la donnée base64
//         if (base64Data.length > 50000) {
//           console.warn(`Données base64 trop longues pour "${article.title}", utilisation image par défaut`);
//           return getDefaultImage(article.category);
//         }

//         // Détecter le type de fichier (simple heuristique)
//         let mimeType = 'image/jpeg';
//         if (base64Data.startsWith('/9j/')) mimeType = 'image/jpeg';
//         else if (base64Data.startsWith('iVBOR')) mimeType = 'image/png';
//         else if (base64Data.startsWith('R0lGOD')) mimeType = 'image/gif';

//         return `data:${mimeType};base64,${base64Data}`;
//       }

//       // Type inconnu, utiliser l'image par défaut
//       console.warn(`Type d'image inconnu pour "${article.title}":`, article.imageType);
//       return getDefaultImage(article.category);

//     } catch (error) {
//       console.error(`Erreur lors du traitement de l'image pour "${article.title}":`, error);
//       return getDefaultImage(article.category);
//     }
//   };

//   const ImageComponent = ({ article, height, isMainArticle, index }) => {
//     const [imageSrc, setImageSrc] = useState(null);
//     const [imageError, setImageError] = useState(false);

//     useEffect(() => {
//       const src = processImageSrc(article);
//       setImageSrc(src);
//       setImageError(false);
//     }, [article]);

//     const handleImageError = () => {
//       console.error(`Erreur de chargement final pour "${article.title}"`);
//       if (!imageError) {
//         setImageError(true);
//         setImageSrc(getDefaultImage(article.category));
//       }
//     };

//     const handleImageLoad = () => {
//       console.log(`Image chargée avec succès pour "${article.title}"`);
//     };

//     return (
//       <div 
//         style={{ 
//           height: height,
//           background: `linear-gradient(45deg, ${getCategoryColor(article.category)}20, ${getCategoryColor(article.category)}40)`,
//           position: 'relative',
//           overflow: 'hidden'
//         }}
//       >
//         {imageSrc && (
//           <img
//             alt={article.title}
//             src={imageSrc}
//             style={{
//               width: '100%',
//               height: '100%',
//               objectFit: 'cover',
//               transition: 'transform 0.3s ease',
//             }}
//             onError={handleImageError}
//             onLoad={handleImageLoad}
//             onMouseEnter={(e) => {
//               e.target.style.transform = 'scale(1.05)';
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.transform = 'scale(1)';
//             }}
//           />
//         )}
        
//         {index === 0 && (
//           <div
//             style={{
//               position: 'absolute',
//               top: '16px',
//               left: '16px',
//               background: 'linear-gradient(135deg, #ff6b6b, #feca57)',
//               color: 'white',
//               padding: '6px 12px',
//               borderRadius: '20px',
//               fontSize: '12px',
//               fontWeight: 'bold',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '4px'
//             }}
//           >
//             <FireOutlined />
//             À la une
//           </div>
//         )}
//       </div>
//     );
//   };

//   const renderNewsCard = (article, index) => {
//     const isMainArticle = index === 0;
    
//     if (!article) {
//       return null;
//     }
    
//     return (
//       <Col 
//         xs={24} 
//         sm={isMainArticle ? 24 : 12} 
//         md={isMainArticle ? 12 : 8} 
//         lg={isMainArticle ? 12 : 6}
//         key={article.id || index}
//       >
//         <Card
//           hoverable
//           onClick={() => handleArticleClick(article)}
//           style={{
//             height: '100%',
//             borderRadius: '16px',
//             overflow: 'hidden',
//             border: 'none',
//             boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
//             transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//             position: 'relative',
//             cursor: 'pointer'
//           }}
//           bodyStyle={{ 
//             padding: isMainArticle ? '24px' : '20px',
//             height: '100%',
//             display: 'flex',
//             flexDirection: 'column'
//           }}
//           cover={
//             <ImageComponent 
//               article={article}
//               height={isMainArticle ? '280px' : '200px'}
//               isMainArticle={isMainArticle}
//               index={index}
//             />
//           }
//         >
//           <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
//             {/* Catégorie et date */}
//             <div style={{ marginBottom: '12px' }}>
//               <Space wrap>
//                 {article.category && (
//                   <Tag 
//                     color={getCategoryColor(article.category)}
//                     style={{ 
//                       borderRadius: '12px',
//                       fontSize: '11px',
//                       fontWeight: '500',
//                       textTransform: 'uppercase',
//                       letterSpacing: '0.5px'
//                     }}
//                   >
//                     {article.category}
//                   </Tag>
//                 )}
//                 <Text 
//                   type="secondary" 
//                   style={{ 
//                     fontSize: '12px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '4px'
//                   }}
//                 >
//                   <CalendarOutlined />
//                   {formatDate(article.createdDate)}
//                 </Text>
//               </Space>
//             </div>

//             {/* Titre */}
//             <Title 
//               level={isMainArticle ? 3 : 4} 
//               style={{ 
//                 marginBottom: '12px',
//                 lineHeight: '1.3',
//                 fontSize: isMainArticle ? '24px' : '16px',
//                 fontWeight: '600',
//                 color: '#262626'
//               }}
//               ellipsis={{ rows: 2 }}
//             >
//               {article.title || 'Titre non disponible'}
//             </Title>

//             {/* Résumé */}
//             <Paragraph
//               style={{ 
//                 color: '#666',
//                 fontSize: isMainArticle ? '15px' : '14px',
//                 lineHeight: '1.6',
//                 marginBottom: '16px',
//                 flex: 1
//               }}
//               ellipsis={{ rows: isMainArticle ? 3 : 2 }}
//             >
//               {article.summary || article.content || 'Contenu non disponible'}
//             </Paragraph>

//             {/* Footer avec auteur et temps de lecture */}
//             <div style={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               marginTop: 'auto',
//               paddingTop: '16px',
//               borderTop: '1px solid #f0f0f0'
//             }}>
//               <Space>
//                 <Avatar 
//                   size="small" 
//                   icon={<UserOutlined />} 
//                   style={{ backgroundColor: getCategoryColor(article.category) }}
//                 />
//                 <Text 
//                   style={{ 
//                     fontSize: '12px', 
//                     color: '#666',
//                     fontWeight: '500'
//                   }}
//                 >
//                   {article.author || 'Équipe Nomidya'}
//                 </Text>
//               </Space>
              
//               <Space>
//                 {article.readingTime && (
//                   <Text 
//                     style={{ 
//                       fontSize: '12px', 
//                       color: '#666',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '4px'
//                     }}
//                   >
//                     <ClockCircleOutlined />
//                     {article.readingTime} min
//                   </Text>
//                 )}
//                 <Button 
//                   type="text" 
//                   size="small"
//                   icon={<EyeOutlined />}
//                   onClick={(e) => {
//                     e.stopPropagation(); // Empêcher le déclenchement du onClick de la Card
//                     handleArticleClick(article);
//                   }}
//                   style={{ 
//                     color: getCategoryColor(article.category),
//                     fontWeight: '500',
//                     fontSize: '12px'
//                   }}
//                 >
//                   Lire plus
//                 </Button>
//               </Space>
//             </div>
//           </div>
//         </Card>
//       </Col>
//     );
//   };

//   if (loading) {
//     return (
//       <div style={{ padding: '40px 20px', backgroundColor: '#fafafa' }}>
//         <div style={{ textAlign: 'center', marginBottom: '40px' }}>
//           <Skeleton.Input active style={{ height: '40px', width: '300px' }} />
//           <br />
//           <Skeleton.Input active style={{ height: '20px', width: '500px', marginTop: '16px' }} />
//         </div>
//         <Row gutter={[24, 24]}>
//           {[...Array(6)].map((_, index) => (
//             <Col xs={24} sm={12} md={8} lg={6} key={index}>
//               <Card>
//                 <Skeleton.Image style={{ width: '100%', height: '200px' }} />
//                 <Skeleton active paragraph={{ rows: 3 }} />
//               </Card>
//             </Col>
//           ))}
//         </Row>
//       </div>
//     );
//   }

//   return (
//     <div 
//       style={{ 
//         padding: '60px 20px',
//         background: 'linear-gradient(180deg, #fafafa 0%, #ffffff 100%)',
//         position: 'relative'
//       }}
//     >
//       {/* Background decoration */}
//       <div
//         style={{
//           position: 'absolute',
//           top: 0,
//           right: 0,
//           width: '300px',
//           height: '300px',
//           background: 'linear-gradient(135deg, #1890ff10, #722ed110)',
//           borderRadius: '50%',
//           transform: 'translate(50%, -50%)',
//           zIndex: 0
//         }}
//       />

//       <div style={{ maxWidth: '1400px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
//         {/* Header */}
//         <div style={{ textAlign: 'center', marginBottom: '50px' }}>
//           <Title 
//             level={2} 
//             style={{ 
//               color: '#004b8d',
//               marginBottom: '16px',
//               fontSize: '36px',
//               fontWeight: '700',
//               background: 'linear-gradient(135deg, #004b8d, #1890ff)',
//               WebkitBackgroundClip: 'text',
//               WebkitTextFillColor: 'transparent'
//             }}
//           >
//             <ReadOutlined style={{ marginRight: '12px' }} />
//             Actualités E-Learning
//           </Title>
//           <Text 
//             style={{ 
//               fontSize: '18px', 
//               color: '#666',
//               fontWeight: '400',
//               letterSpacing: '0.5px'
//             }}
//           >
//             Découvrez les dernières innovations et tendances dans l'éducation en ligne
//           </Text>
//         </div>

//         {/* News Grid */}
//         {news.length > 0 ? (
//           <Row gutter={[24, 24]} align="stretch">
//             {news.map((article, index) => renderNewsCard(article, index))}
//           </Row>
//         ) : (
//           <div style={{ textAlign: 'center', padding: '60px 20px' }}>
//             <ReadOutlined 
//               style={{ 
//                 fontSize: '64px', 
//                 color: '#d9d9d9', 
//                 marginBottom: '16px' 
//               }} 
//             />
//             <Title level={4} style={{ color: '#999' }}>
//               Aucune actualité disponible
//             </Title>
//             <Text style={{ color: '#666' }}>
//               Revenez bientôt pour découvrir nos dernières nouvelles !
//             </Text>
//           </div>
//         )}

//         {/* Call to action */}
//         {news.length > 0 && (
//           <div style={{ textAlign: 'center', marginTop: '50px' }}>
//             <Button 
//               size="large"
//               onClick={handleViewAllNews}
//               style={{
//                 background: 'linear-gradient(135deg, #1890ff, #722ed1)',
//                 border: 'none',
//                 color: 'white',
//                 borderRadius: '25px',
//                 padding: '0 40px',
//                 height: '48px',
//                 fontSize: '16px',
//                 fontWeight: '600',
//                 boxShadow: '0 8px 24px rgba(24, 144, 255, 0.3)',
//                 transition: 'all 0.3s ease'
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.transform = 'translateY(-2px)';
//                 e.target.style.boxShadow = '0 12px 32px rgba(24, 144, 255, 0.4)';
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.transform = 'translateY(0)';
//                 e.target.style.boxShadow = '0 8px 24px rgba(24, 144, 255, 0.3)';
//               }}
//             >
//               Voir toutes les actualités
//               <RightOutlined style={{ marginLeft: '8px' }} />
//             </Button>
//           </div>
//         )}
//       </div>
      
//       {/* Modal de détails d'une actualité */}
//       <Modal
//         title={null}
//         open={detailModalVisible}
//         onCancel={closeDetailModal}
//         footer={null}
//         width={800}
//         centered
//         closeIcon={<CloseOutlined style={{ fontSize: '20px', color: '#666' }} />}
//       >
//         {selectedArticle && (
//           <div>
//             {/* Image de l'actualité */}
//             <div style={{ marginBottom: '24px' }}>
//               <ImageComponent 
//                 article={selectedArticle}
//                 height="300px"
//                 isMainArticle={true}
//                 index={-1}
//               />
//             </div>

//             {/* Métadonnées */}
//             <div style={{ marginBottom: '20px' }}>
//               <Space wrap>
//                 {selectedArticle.category && (
//                   <Tag 
//                     color={getCategoryColor(selectedArticle.category)}
//                     style={{ 
//                       borderRadius: '12px',
//                       fontSize: '12px',
//                       fontWeight: '500',
//                       textTransform: 'uppercase',
//                       letterSpacing: '0.5px',
//                       padding: '4px 12px'
//                     }}
//                   >
//                     {selectedArticle.category}
//                   </Tag>
//                 )}
//                 <Text type="secondary">
//                   <CalendarOutlined /> {formatDate(selectedArticle.createdDate)}
//                 </Text>
//                 {selectedArticle.readingTime && (
//                   <Text type="secondary">
//                     <ClockCircleOutlined /> {selectedArticle.readingTime} min de lecture
//                   </Text>
//                 )}
//                 {selectedArticle.author && (
//                   <Text type="secondary">
//                     <UserOutlined /> {selectedArticle.author}
//                   </Text>
//                 )}
//               </Space>
//             </div>

//             {/* Titre */}
//             <Title 
//               level={2} 
//               style={{ 
//                 marginBottom: '16px',
//                 color: '#262626',
//                 fontSize: '28px',
//                 fontWeight: '700',
//                 lineHeight: '1.3'
//               }}
//             >
//               {selectedArticle.title}
//             </Title>

//             {/* Résumé */}
//             {selectedArticle.summary && (
//               <div 
//                 style={{ 
//                   background: '#f8f9fa',
//                   padding: '16px',
//                   borderRadius: '8px',
//                   marginBottom: '24px',
//                   border: `2px solid ${getCategoryColor(selectedArticle.category)}20`
//                 }}
//               >
//                 <Text 
//                   style={{ 
//                     fontSize: '16px',
//                     fontWeight: '500',
//                     color: '#666',
//                     fontStyle: 'italic'
//                   }}
//                 >
//                   {selectedArticle.summary}
//                 </Text>
//               </div>
//             )}

//             {/* Contenu */}
//             <div style={{ marginBottom: '24px' }}>
//               <Paragraph 
//                 style={{ 
//                   fontSize: '16px',
//                   lineHeight: '1.8',
//                   color: '#444',
//                   textAlign: 'justify'
//                 }}
//               >
//                 {selectedArticle.content}
//               </Paragraph>
//             </div>

//             {/* Footer de l'article */}
//             <div 
//               style={{ 
//                 borderTop: '1px solid #f0f0f0',
//                 paddingTop: '20px',
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center'
//               }}
//             >
//               <Space>
//                 <Avatar 
//                   size="medium" 
//                   icon={<UserOutlined />} 
//                   style={{ backgroundColor: getCategoryColor(selectedArticle.category) }}
//                 />
//                 <div>
//                   <div style={{ fontWeight: '500', color: '#262626' }}>
//                     {selectedArticle.author || 'Équipe Nomidya'}
//                   </div>
//                   <div style={{ fontSize: '12px', color: '#999' }}>
//                     Publié le {formatDate(selectedArticle.createdDate)}
//                   </div>
//                 </div>
//               </Space>
              
//               <Button 
//                 type="primary" 
//                 onClick={closeDetailModal}
//                 style={{
//                   background: getCategoryColor(selectedArticle.category),
//                   borderColor: getCategoryColor(selectedArticle.category),
//                   borderRadius: '6px'
//                 }}
//               >
//                 Fermer
//               </Button>
//             </div>
//           </div>
//         )}
//       </Modal>

//       {/* Drawer pour toutes les actualités */}
//       <Drawer
//         title={
//           <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//             <ReadOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
//             <span style={{ fontSize: '18px', fontWeight: '600' }}>
//               Toutes les actualités
//             </span>
//           </div>
//         }
//         placement="right"
//         onClose={closeAllNewsDrawer}
//         open={allNewsVisible}
//         width={600}
//         closeIcon={<CloseOutlined style={{ fontSize: '18px' }} />}
//       >
//         {loadingAllNews ? (
//           <div>
//             {[...Array(5)].map((_, index) => (
//               <Card key={index} style={{ marginBottom: '16px' }}>
//                 <Skeleton.Image style={{ width: '100%', height: '150px' }} />
//                 <Skeleton active paragraph={{ rows: 2 }} style={{ marginTop: '16px' }} />
//               </Card>
//             ))}
//           </div>
//         ) : (
//           <div>
//             {allNews.length > 0 ? (
//               <Row gutter={[0, 16]}>
//                 {allNews.map((article, index) => (
//                   <Col span={24} key={article.id || index}>
//                     <Card
//                       hoverable
//                       onClick={() => handleArticleClick(article)}
//                       style={{
//                         borderRadius: '12px',
//                         overflow: 'hidden',
//                         cursor: 'pointer',
//                         border: '1px solid #f0f0f0'
//                       }}
//                       bodyStyle={{ padding: '16px' }}
//                     >
//                       <Row gutter={16}>
//                         <Col span={8}>
//                           <div style={{ height: '100px', borderRadius: '8px', overflow: 'hidden' }}>
//                             <ImageComponent 
//                               article={article}
//                               height="100px"
//                               isMainArticle={false}
//                               index={index}
//                             />
//                           </div>
//                         </Col>
//                         <Col span={16}>
//                           <div style={{ height: '100px', display: 'flex', flexDirection: 'column' }}>
//                             <div style={{ marginBottom: '8px' }}>
//                               <Space>
//                                 {article.category && (
//                                   <Tag 
//                                     color={getCategoryColor(article.category)}
//                                     style={{ fontSize: '10px', padding: '2px 8px' }}
//                                   >
//                                     {article.category}
//                                   </Tag>
//                                 )}
//                                 <Text type="secondary" style={{ fontSize: '11px' }}>
//                                   {formatDate(article.createdDate)}
//                                 </Text>
//                               </Space>
//                             </div>
                            
//                             <Title 
//                               level={5} 
//                               style={{ 
//                                 marginBottom: '8px',
//                                 fontSize: '14px',
//                                 lineHeight: '1.4'
//                               }}
//                               ellipsis={{ rows: 2 }}
//                             >
//                               {article.title}
//                             </Title>
                            
//                             <Text 
//                               type="secondary" 
//                               style={{ 
//                                 fontSize: '12px',
//                                 lineHeight: '1.4',
//                                 flex: 1
//                               }}
//                               ellipsis={{ rows: 2 }}
//                             >
//                               {article.summary || article.content}
//                             </Text>
//                           </div>
//                         </Col>
//                       </Row>
//                     </Card>
//                   </Col>
//                 ))}
//               </Row>
//             ) : (
//               <div style={{ textAlign: 'center', padding: '40px 20px' }}>
//                 <ReadOutlined 
//                   style={{ 
//                     fontSize: '48px', 
//                     color: '#d9d9d9', 
//                     marginBottom: '16px' 
//                   }} 
//                 />
//                 <Title level={4} style={{ color: '#999' }}>
//                   Aucune actualité disponible
//                 </Title>
//               </div>
//             )}
//           </div>
//         )}
//       </Drawer>
//     </div>
//   );
// };

// export default NewsSection;



import React, { useState, useEffect } from 'react';
import { Row, Col, Typography, Button, Tag, Skeleton, Space, Avatar, Modal, Drawer, Card } from 'antd';
import {
  CalendarOutlined,
  ClockCircleOutlined,
  UserOutlined,
  ReadOutlined,
  RightOutlined,
  FireOutlined,
  EyeOutlined,
  CloseOutlined
} from '@ant-design/icons';
import newsService from "../../services/course.service";

const { Title, Text, Paragraph } = Typography;

/* ============ Couleurs logo Nomidya ============ */
const C = {
  blue: "#0054A6",
  blueDark: "#003B75",
  blueLight: "#e8f1fb",
  orange: "#E8860C",
  orangeLight: "#FF8C00",
  orangeBg: "#fff8f0",
  text: "#333",
  textLight: "#888",
  border: "#eaedf2",
  bg: "#f7f8fa",
};

const NewsSection = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [allNewsVisible, setAllNewsVisible] = useState(false);
  const [allNews, setAllNews] = useState([]);
  const [loadingAllNews, setLoadingAllNews] = useState(false);

  useEffect(() => { fetchLatestNews(); }, []);

  const fetchLatestNews = async () => {
    try {
      setLoading(true);
      const data = await newsService.getLatestNews(6);
      setNews(data || []);
    } catch (error) {
      console.error('Erreur chargement actualités:', error);
      setNews([]);
    } finally { setLoading(false); }
  };

  const fetchAllNews = async () => {
    try {
      setLoadingAllNews(true);
      const data = await newsService.getAllNews();
      setAllNews(data || []);
    } catch (error) {
      console.error('Erreur chargement actualités:', error);
      setAllNews([]);
    } finally { setLoadingAllNews(false); }
  };

  const handleArticleClick = (article) => { setSelectedArticle(article); setDetailModalVisible(true); };
  const handleViewAllNews = () => { fetchAllNews(); setAllNewsVisible(true); };
  const closeDetailModal = () => { setDetailModalVisible(false); setSelectedArticle(null); };
  const closeAllNewsDrawer = () => { setAllNewsVisible(false); setAllNews([]); };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      return new Date(dateString).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch { return ''; }
  };

  const getCategoryColor = (category) => {
    const colors = {
      'elearning': C.blue, 'technology': '#7C3AED', 'education': '#00875A',
      'innovation': C.orange, 'updates': '#DC2626', 'events': '#0891B2', 'default': C.textLight,
    };
    return colors[category?.toLowerCase()] || colors.default;
  };

  const getDefaultImage = (category) => {
    const imgs = {
      'elearning': 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=600&h=400&fit=crop',
      'technology': 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=600&h=400&fit=crop',
      'education': 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600&h=400&fit=crop',
      'innovation': 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=400&fit=crop',
      'updates': 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop',
      'events': 'https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=600&h=400&fit=crop',
      'default': 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop',
    };
    return imgs[category?.toLowerCase()] || imgs.default;
  };

  const processImageSrc = (article) => {
    if (!article.imageData || article.imageData.trim() === '') return getDefaultImage(article.category);
    try {
      if (article.imageType === 'url') {
        if (article.imageData.startsWith('http://') || article.imageData.startsWith('https://')) return article.imageData;
        return getDefaultImage(article.category);
      }
      if (article.imageType === 'base64') {
        let b = article.imageData;
        if (b.startsWith('data:')) return b.length > 100000 ? getDefaultImage(article.category) : b;
        if (b.length > 50000) return getDefaultImage(article.category);
        let m = 'image/jpeg';
        if (b.startsWith('/9j/')) m = 'image/jpeg';
        else if (b.startsWith('iVBOR')) m = 'image/png';
        else if (b.startsWith('R0lGOD')) m = 'image/gif';
        return `data:${m};base64,${b}`;
      }
      return getDefaultImage(article.category);
    } catch { return getDefaultImage(article.category); }
  };

  const ImageComponent = ({ article, height, index }) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [imageError, setImageError] = useState(false);

    useEffect(() => { setImageSrc(processImageSrc(article)); setImageError(false); }, [article]);

    return (
      <div style={{ height, background: C.bg, position: 'relative', overflow: 'hidden' }}>
        {imageSrc && (
          <img alt={article.title} src={imageSrc}
            style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.3s' }}
            onError={() => { if (!imageError) { setImageError(true); setImageSrc(getDefaultImage(article.category)); } }}
            onMouseEnter={e => e.target.style.transform = 'scale(1.05)'}
            onMouseLeave={e => e.target.style.transform = 'scale(1)'}
          />
        )}
        {index === 0 && (
          <div style={{
            position: 'absolute', top: 10, left: 10,
            background: `linear-gradient(135deg, ${C.orange}, ${C.orangeLight})`,
            color: 'white', padding: '3px 10px', borderRadius: 12,
            fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 4,
          }}>
            <FireOutlined /> À la une
          </div>
        )}
      </div>
    );
  };

  /* ============ Carte d'article ============ */
  const renderNewsCard = (article, index) => {
    if (!article) return null;
    const isMain = index === 0;

    return (
      <Col xs={24} sm={isMain ? 24 : 12} md={isMain ? 12 : 8} lg={isMain ? 12 : 6} key={article.id || index}>
        <div
          onClick={() => handleArticleClick(article)}
          style={{
            height: '100%', borderRadius: 12, overflow: 'hidden', background: 'white',
            border: `1px solid ${C.border}`, boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
            transition: 'all 0.3s ease', cursor: 'pointer', display: 'flex', flexDirection: 'column',
          }}
          onMouseEnter={e => { e.currentTarget.style.boxShadow = `0 8px 24px ${C.blue}12`; e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.borderColor = C.blue; }}
          onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = C.border; }}
        >
          <ImageComponent article={article} height={isMain ? '200px' : '140px'} index={index} />

          <div style={{ padding: isMain ? '16px' : '12px 14px', flex: 1, display: 'flex', flexDirection: 'column' }}>
            {/* Category + date */}
            <div style={{ marginBottom: 8 }}>
              <Space size={6} wrap>
                {article.category && (
                  <Tag color={getCategoryColor(article.category)} style={{ borderRadius: 10, fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.3 }}>
                    {article.category}
                  </Tag>
                )}
                <Text style={{ fontSize: 10, color: C.textLight, display: 'flex', alignItems: 'center', gap: 3 }}>
                  <CalendarOutlined /> {formatDate(article.createdDate)}
                </Text>
              </Space>
            </div>

            {/* Titre */}
            <h3 style={{
              margin: '0 0 6px', fontSize: isMain ? 16 : 13, fontWeight: 700,
              color: C.blueDark, lineHeight: 1.35, overflow: 'hidden',
              display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
            }}>
              {article.title || 'Titre non disponible'}
            </h3>

            {/* Résumé */}
            <p style={{
              margin: '0 0 10px', fontSize: isMain ? 13 : 12, color: C.textLight,
              lineHeight: 1.5, flex: 1, overflow: 'hidden',
              display: '-webkit-box', WebkitLineClamp: isMain ? 3 : 2, WebkitBoxOrient: 'vertical',
            }}>
              {article.summary || article.content || 'Contenu non disponible'}
            </p>

            {/* Footer */}
            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              marginTop: 'auto', paddingTop: 8, borderTop: `1px solid ${C.border}`,
            }}>
              <Space size={6}>
                <Avatar size={20} icon={<UserOutlined />} style={{ backgroundColor: getCategoryColor(article.category) }} />
                <Text style={{ fontSize: 10, color: C.textLight, fontWeight: 500 }}>
                  {article.author || 'Équipe Nomidya'}
                </Text>
              </Space>
              <Space size={6}>
                {article.readingTime && (
                  <Text style={{ fontSize: 10, color: C.textLight, display: 'flex', alignItems: 'center', gap: 3 }}>
                    <ClockCircleOutlined /> {article.readingTime} min
                  </Text>
                )}
                <span style={{ fontSize: 10, color: C.blue, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 3 }}>
                  <EyeOutlined /> Lire
                </span>
              </Space>
            </div>
          </div>
        </div>
      </Col>
    );
  };

  /* ============ Loading ============ */
  if (loading) {
    return (
      <div style={{ padding: '32px 20px', background: 'white' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Skeleton.Input active style={{ height: 28, width: 200 }} />
        </div>
        <Row gutter={[16, 16]}>
          {[...Array(4)].map((_, i) => (
            <Col xs={24} sm={12} md={8} lg={6} key={i}>
              <Card style={{ borderRadius: 12 }}>
                <Skeleton.Image style={{ width: '100%', height: 140 }} />
                <Skeleton active paragraph={{ rows: 2 }} />
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  /* ============ RENDER ============ */
  return (
    <div style={{
      padding: '44px 24px', background: 'white',
      borderBottom: `1px solid ${C.border}`,
      fontFamily: "'Outfit', -apple-system, sans-serif",
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>

        {/* Header — même style que les autres sections */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <span style={{
            fontSize: 11, fontWeight: 700, color: C.orange, letterSpacing: 1.5,
            textTransform: 'uppercase', display: 'inline-block',
            padding: '3px 12px', borderRadius: 12, background: C.orangeBg, marginBottom: 8,
          }}>
            Actualités
          </span>
          <h2 style={{
            color: C.blueDark, fontSize: 28, fontWeight: 800, margin: '8px 0 6px',
          }}>
            Actualités <span style={{ color: C.orange }}>E-Learning</span>
          </h2>
          <p style={{ fontSize: 14, color: C.textLight, margin: 0 }}>
            Découvrez les dernières innovations et tendances dans l'éducation en ligne
          </p>
        </div>

        {/* News Grid */}
        {news.length > 0 ? (
          <Row gutter={[16, 16]} align="stretch">
            {news.map((article, index) => renderNewsCard(article, index))}
          </Row>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px 20px' }}>
            <ReadOutlined style={{ fontSize: 40, color: '#ddd', marginBottom: 12 }} />
            <h4 style={{ color: C.textLight, fontWeight: 600 }}>Aucune actualité disponible</h4>
            <p style={{ color: C.textLight, fontSize: 13 }}>Revenez bientôt pour découvrir nos dernières nouvelles !</p>
          </div>
        )}

        {/* CTA button */}
        {news.length > 0 && (
          <div style={{ textAlign: 'center', marginTop: 28 }}>
            <button
              onClick={handleViewAllNews}
              style={{
                background: C.blue, border: 'none', color: 'white',
                borderRadius: 8, padding: '10px 28px', fontSize: 13,
                fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
                boxShadow: `0 3px 12px ${C.blue}22`, transition: 'all 0.3s',
              }}
              onMouseEnter={e => { e.currentTarget.style.opacity = '0.88'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              Voir toutes les actualités <RightOutlined style={{ marginLeft: 6 }} />
            </button>
          </div>
        )}
      </div>

      {/* ============ Modal détail article ============ */}
      <Modal
        title={null} open={detailModalVisible} onCancel={closeDetailModal}
        footer={null} width={700} centered
        closeIcon={<CloseOutlined style={{ fontSize: 16, color: C.textLight }} />}
      >
        {selectedArticle && (
          <div>
            <div style={{ marginBottom: 16, borderRadius: 10, overflow: 'hidden' }}>
              <ImageComponent article={selectedArticle} height="240px" index={-1} />
            </div>

            <div style={{ marginBottom: 14 }}>
              <Space size={8} wrap>
                {selectedArticle.category && (
                  <Tag color={getCategoryColor(selectedArticle.category)}
                    style={{ borderRadius: 10, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', padding: '2px 10px' }}>
                    {selectedArticle.category}
                  </Tag>
                )}
                <Text style={{ fontSize: 12, color: C.textLight }}><CalendarOutlined /> {formatDate(selectedArticle.createdDate)}</Text>
                {selectedArticle.readingTime && (
                  <Text style={{ fontSize: 12, color: C.textLight }}><ClockCircleOutlined /> {selectedArticle.readingTime} min</Text>
                )}
                {selectedArticle.author && (
                  <Text style={{ fontSize: 12, color: C.textLight }}><UserOutlined /> {selectedArticle.author}</Text>
                )}
              </Space>
            </div>

            <h2 style={{ margin: '0 0 12px', color: C.blueDark, fontSize: 22, fontWeight: 800, lineHeight: 1.3 }}>
              {selectedArticle.title}
            </h2>

            {selectedArticle.summary && (
              <div style={{
                background: C.blueLight, padding: 14, borderRadius: 8, marginBottom: 16,
                borderLeft: `3px solid ${C.blue}`,
              }}>
                <Text style={{ fontSize: 13, fontWeight: 500, color: '#555', fontStyle: 'italic' }}>
                  {selectedArticle.summary}
                </Text>
              </div>
            )}

            <div style={{ marginBottom: 16 }}>
              <p style={{ fontSize: 14, lineHeight: 1.8, color: '#444', textAlign: 'justify' }}>
                {selectedArticle.content}
              </p>
            </div>

            <div style={{
              borderTop: `1px solid ${C.border}`, paddingTop: 14,
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            }}>
              <Space size={8}>
                <Avatar size={28} icon={<UserOutlined />} style={{ backgroundColor: getCategoryColor(selectedArticle.category) }} />
                <div>
                  <div style={{ fontWeight: 600, color: C.blueDark, fontSize: 13 }}>{selectedArticle.author || 'Équipe Nomidya'}</div>
                  <div style={{ fontSize: 10, color: C.textLight }}>Publié le {formatDate(selectedArticle.createdDate)}</div>
                </div>
              </Space>
              <Button type="primary" onClick={closeDetailModal}
                style={{ background: C.blue, borderColor: C.blue, borderRadius: 8, fontWeight: 600, fontSize: 12 }}>
                Fermer
              </Button>
            </div>
          </div>
        )}
      </Modal>

      {/* ============ Drawer toutes les actualités ============ */}
      <Drawer
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <ReadOutlined style={{ color: C.blue, fontSize: 16 }} />
            <span style={{ fontSize: 15, fontWeight: 700, color: C.blueDark }}>Toutes les actualités</span>
          </div>
        }
        placement="right" onClose={closeAllNewsDrawer} open={allNewsVisible}
        width={520} closeIcon={<CloseOutlined style={{ fontSize: 14 }} />}
      >
        {loadingAllNews ? (
          <div>
            {[...Array(4)].map((_, i) => (
              <Card key={i} style={{ marginBottom: 12, borderRadius: 10 }}>
                <Skeleton active paragraph={{ rows: 2 }} />
              </Card>
            ))}
          </div>
        ) : allNews.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {allNews.map((article, index) => (
              <div key={article.id || index}
                onClick={() => handleArticleClick(article)}
                style={{
                  display: 'flex', gap: 12, padding: 12, borderRadius: 10,
                  border: `1px solid ${C.border}`, cursor: 'pointer', transition: 'all 0.2s',
                  background: 'white',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = C.blue; e.currentTarget.style.boxShadow = `0 4px 12px ${C.blue}10`; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.boxShadow = 'none'; }}
              >
                <div style={{ width: 80, height: 70, borderRadius: 8, overflow: 'hidden', flexShrink: 0 }}>
                  <ImageComponent article={article} height="70px" index={-1} />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Space size={4} style={{ marginBottom: 4 }}>
                    {article.category && (
                      <Tag color={getCategoryColor(article.category)} style={{ fontSize: 9, padding: '1px 6px', borderRadius: 8 }}>
                        {article.category}
                      </Tag>
                    )}
                    <Text style={{ fontSize: 10, color: C.textLight }}>{formatDate(article.createdDate)}</Text>
                  </Space>
                  <h4 style={{
                    margin: '0 0 4px', fontSize: 13, fontWeight: 700, color: C.blueDark,
                    lineHeight: 1.3, overflow: 'hidden',
                    display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                  }}>
                    {article.title}
                  </h4>
                  <p style={{
                    margin: 0, fontSize: 11, color: C.textLight, lineHeight: 1.4,
                    overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical',
                  }}>
                    {article.summary || article.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px 20px' }}>
            <ReadOutlined style={{ fontSize: 36, color: '#ddd', marginBottom: 12 }} />
            <h4 style={{ color: C.textLight }}>Aucune actualité</h4>
          </div>
        )}
      </Drawer>
    </div>
  );
};

export default NewsSection;